<h1>Notes</h1>
<div class="notes">
  <ul>
    <li *ngFor="let note of notes">{{ note }}</li>
  </ul>
  <input type="text" [(ngModel)]="note" autofocus />
  <button (click)="createNote()">Create note</button>
</div>

<div>
    <!-- <app-summary [total]="totalList" ></app-summary> -->
    <app-summary (messageEvent)="receiveMessage($event)" (seccondEvent)="receiveSecondMessage($event)"></app-summary>
</div>
<br>
<div>
    <p>{{message}}</p>
</div>